// Modal.js
import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const Modal = ({ isOpen, onClose }) => {
    return (
        isOpen && (
            <motion.div
                className="modal-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                    className="modal-contents"
                    initial={{ scale: 0.5, x: 300 }}
                    animate={{ scale: 1, x: 0 }}
                    exit={{ scale: 0.5, x: 300 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                >
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                    <h2 className='text-center mt-4 text_20_about'>Join the waitlist</h2>
                    <p className='text-center text_18_about'>Be the first to build your vault and test out new features.</p>
                    <div className="modal_input">
                        <input type="email" placeholder="Enter your email" />
                        <button className="submit-btn">Submit</button>
                    </div>
                    <p className="text_18_about mt-4 text-center" style={{
                        fontSize: "14px",
                    }}>Unsubscribe</p>
                </motion.div>
            </motion.div>
        )
    );
};

export default Modal;
